export interface Country {
  code: string; // Country calling code (e.g., "+91")
  countryCode: string; // ISO country code (e.g., "IN")
  name: string;
  flag: string; // Emoji flag
  maxLength: number; // Maximum phone number length (without country code)
}

export const COUNTRIES: Country[] = [
  // South Asia
  { code: '+91', countryCode: 'IN', name: 'India', flag: '🇮🇳', maxLength: 10 },
  { code: '+92', countryCode: 'PK', name: 'Pakistan', flag: '🇵🇰', maxLength: 10 },
  { code: '+880', countryCode: 'BD', name: 'Bangladesh', flag: '🇧🇩', maxLength: 10 },
  { code: '+94', countryCode: 'LK', name: 'Sri Lanka', flag: '🇱🇰', maxLength: 9 },
  { code: '+977', countryCode: 'NP', name: 'Nepal', flag: '🇳🇵', maxLength: 10 },
  
  // Southeast Asia
  { code: '+65', countryCode: 'SG', name: 'Singapore', flag: '🇸🇬', maxLength: 8 },
  { code: '+60', countryCode: 'MY', name: 'Malaysia', flag: '🇲🇾', maxLength: 10 },
  { code: '+62', countryCode: 'ID', name: 'Indonesia', flag: '🇮🇩', maxLength: 12 },
  { code: '+66', countryCode: 'TH', name: 'Thailand', flag: '🇹🇭', maxLength: 9 },
  { code: '+84', countryCode: 'VN', name: 'Vietnam', flag: '🇻🇳', maxLength: 10 },
  { code: '+63', countryCode: 'PH', name: 'Philippines', flag: '🇵🇭', maxLength: 10 },
  
  // Middle East
  { code: '+971', countryCode: 'AE', name: 'UAE', flag: '🇦🇪', maxLength: 9 },
  { code: '+966', countryCode: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', maxLength: 9 },
  { code: '+974', countryCode: 'QA', name: 'Qatar', flag: '🇶🇦', maxLength: 8 },
  { code: '+965', countryCode: 'KW', name: 'Kuwait', flag: '🇰🇼', maxLength: 8 },
  { code: '+968', countryCode: 'OM', name: 'Oman', flag: '🇴🇲', maxLength: 8 },
  { code: '+973', countryCode: 'BH', name: 'Bahrain', flag: '🇧🇭', maxLength: 8 },
  
  // East Asia
  { code: '+86', countryCode: 'CN', name: 'China', flag: '🇨🇳', maxLength: 11 },
  { code: '+81', countryCode: 'JP', name: 'Japan', flag: '🇯🇵', maxLength: 10 },
  { code: '+82', countryCode: 'KR', name: 'South Korea', flag: '🇰🇷', maxLength: 10 },
  { code: '+852', countryCode: 'HK', name: 'Hong Kong', flag: '🇭🇰', maxLength: 8 },
  
  // North America
  { code: '+1', countryCode: 'US', name: 'United States', flag: '🇺🇸', maxLength: 10 },
  { code: '+1', countryCode: 'CA', name: 'Canada', flag: '🇨🇦', maxLength: 10 },
  { code: '+52', countryCode: 'MX', name: 'Mexico', flag: '🇲🇽', maxLength: 10 },
  
  // Europe
  { code: '+44', countryCode: 'GB', name: 'United Kingdom', flag: '🇬🇧', maxLength: 10 },
  { code: '+49', countryCode: 'DE', name: 'Germany', flag: '🇩🇪', maxLength: 11 },
  { code: '+33', countryCode: 'FR', name: 'France', flag: '🇫🇷', maxLength: 9 },
  { code: '+39', countryCode: 'IT', name: 'Italy', flag: '🇮🇹', maxLength: 10 },
  { code: '+34', countryCode: 'ES', name: 'Spain', flag: '🇪🇸', maxLength: 9 },
  { code: '+31', countryCode: 'NL', name: 'Netherlands', flag: '🇳🇱', maxLength: 9 },
  { code: '+41', countryCode: 'CH', name: 'Switzerland', flag: '🇨🇭', maxLength: 9 },
  { code: '+46', countryCode: 'SE', name: 'Sweden', flag: '🇸🇪', maxLength: 10 },
  { code: '+47', countryCode: 'NO', name: 'Norway', flag: '🇳🇴', maxLength: 8 },
  { code: '+45', countryCode: 'DK', name: 'Denmark', flag: '🇩🇰', maxLength: 8 },
  
  // Oceania
  { code: '+61', countryCode: 'AU', name: 'Australia', flag: '🇦🇺', maxLength: 9 },
  { code: '+64', countryCode: 'NZ', name: 'New Zealand', flag: '🇳🇿', maxLength: 10 },
  
  // Africa
  { code: '+27', countryCode: 'ZA', name: 'South Africa', flag: '🇿🇦', maxLength: 9 },
  { code: '+234', countryCode: 'NG', name: 'Nigeria', flag: '🇳🇬', maxLength: 10 },
  { code: '+254', countryCode: 'KE', name: 'Kenya', flag: '🇰🇪', maxLength: 10 },
  { code: '+20', countryCode: 'EG', name: 'Egypt', flag: '🇪🇬', maxLength: 10 },
];

// Default country (India)
export const DEFAULT_COUNTRY = COUNTRIES[0];

// Find country by code
export const findCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(country => country.code === code);
};

// Find country by ISO country code
export const findCountryByISOCode = (isoCode: string): Country | undefined => {
  return COUNTRIES.find(country => country.countryCode === isoCode);
};
